"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const ExpansionPanel_1 = __importDefault(require("@material-ui/core/ExpansionPanel"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography/Typography"));
const ExpansionPanelSummary_1 = __importDefault(require("@material-ui/core/ExpansionPanelSummary"));
const ExpansionPanelDetails_1 = __importDefault(require("@material-ui/core/ExpansionPanelDetails"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const panel_styles_1 = require("./panel-styles");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const compose_refs_1 = require("../../utils/compose-refs");
const evidence_defaults_context_1 = require("../../composite/evidence-defaults/evidence-defaults-context");
exports.Panel = react_1.forwardRef(function Panel({ children, label, summary, expandable = false, defaultExpanded = true, sideBorder = false, bottomBorder = true, unmountOnExit = false, className, fitHeight, }, ref) {
    const { root, fullHeight, summaryRoot, summaryFixed, detailsRoot, detailRootWithSideBorder, detailRootWithBottomBorder, labelRoot, summaryContent, summaryRootWithBorder, sumaryFullHeight, formPanelSummary, } = panel_styles_1.useStyles();
    const { panelUnmountOnExit: defaultUnmountOnExit } = react_1.useContext(evidence_defaults_context_1.EvidenceDefaultsContext);
    const anchorRef = react_1.useRef(null);
    const composedRef = compose_refs_1.composeRefs(ref, anchorRef);
    const [expanded, setExpanded] = react_1.useState(defaultExpanded);
    react_1.useImperativeHandle(ref, () => ({
        setExpanded,
        scrollIntoView: () => {
            var _a;
            (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        },
    }));
    const handleChange = event_callback_hook_1.useEventCallback((event, expanded) => {
        if (expandable) {
            setExpanded(expanded);
        }
    });
    return (react_1.default.createElement(ExpansionPanel_1.default, { className: className, classes: { root: clsx_1.default(root, { [fullHeight]: fitHeight }) }, square: true, expanded: expanded, onChange: handleChange, innerRef: composedRef, TransitionProps: {
            unmountOnExit: unmountOnExit || defaultUnmountOnExit,
            style: fitHeight
                ? {
                    flex: '1 1 auto',
                    overflowY: 'auto',
                }
                : undefined,
        } },
        react_1.default.createElement(ExpansionPanelSummary_1.default, { classes: {
                root: clsx_1.default(summaryRoot, {
                    [summaryFixed]: !expandable,
                    [summaryRootWithBorder]: sideBorder,
                    [sumaryFullHeight]: fitHeight,
                }),
                content: summaryContent,
            }, expandIcon: expandable ? react_1.default.createElement(ExpandMore_1.default, null) : undefined },
            react_1.default.createElement(Typography_1.default, { classes: { root: labelRoot }, variant: "h6" }, label),
            summary && (react_1.default.createElement(Typography_1.default, { component: "div", className: formPanelSummary }, summary))),
        react_1.default.createElement(ExpansionPanelDetails_1.default, { classes: {
                root: clsx_1.default(detailsRoot, {
                    [detailRootWithBottomBorder]: bottomBorder,
                    [detailRootWithSideBorder]: sideBorder,
                }),
            } }, children)));
});
//# sourceMappingURL=panel.js.map